<div class="form_group search_bar">
  <mat-form-field class="srch" appearance="fill">
    <input #search matInput [placeholder]="'SearchHere' | translate" class="form_control" />
  </mat-form-field>
  <button type="button" mat-button matPrefix mat-icon-button>
    <figure *ngIf="!showCrossIcon">
      <img src="{{ assetsConst.searchIcon }}" alt="" />
    </figure>
    <mat-icon
      *ngIf="showCrossIcon"
      (click)="clearInputField()"
      class="close_btn"
      >close</mat-icon
    >
  </button>
</div>
